<template>
  <section
    class="setting-profile-popup mfp-hide popup-save-document"
    id="save-document"
  >
    <a @click="$parent.settingTitle = false" class="profile-edit-close-btn">
      <img src="/assets/img/close-icon.svg" />
    </a>
    <div class="setting-profile-wrapper">
      <div class="save-document-form" v-if="!confirmed">
        <h2>Create a Document</h2>
        <p>Save this as a document, you find it in your documents section</p>

        <div class="form-group">
          <div class="form-field">
            <input
              type="text"
              v-model="name"
              placeholder="Document Name"
              class="form-control"
            />
            <div class="field-check" v-show="name"></div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-field">
            <tinymce
              id="editor"
              ref="tm"
              :other_options="tinymceOptions"
              :toolbar1="toolbar1"
              :initial-value="description"
              placeholder="Description..."
              v-model="description"
              @editorInit="editorIsInit"
            ></tinymce>
            <div class="field-check" v-show="description"></div>
          </div>
        </div>

        <div
          class="custom-control form-field"
          v-if="userData && userData.team_id"
        >
          <span class="switch switch-sm">
            <input
              type="checkbox"
              class="switch"
              v-model="team_shared"
              id="switch-stm"
            />
            <label for="switch-stm">Save as a Team Document</label>
          </span>
          <div class="share-document-info">
            <a
              href="javascript:"
              @mouseover="team_share_tooltip = true"
              @mouseout="team_share_tooltip = false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="20"
                viewBox="0 0 23 20"
              >
                <g>
                  <g>
                    <path
                      d="M11.43 11.5c-.46 0-.831-.387-.831-.865v-5.77c0-.478.372-.865.83-.865.46 0 .831.387.831.865v5.77c0 .478-.372.865-.83.865zM.629 9.75C.629 4.365 5.464 0 11.429 0c5.966 0 10.802 4.365 10.802 9.75S17.395 19.5 11.43 19.5C5.464 19.5.629 15.135.629 9.75zm19.94 0c0-4.556-4.092-8.25-9.14-8.25-5.047 0-9.139 3.694-9.139 8.25S6.382 18 11.43 18c5.047 0 9.139-3.694 9.139-8.25zm-9.97 5c0-.414.372-.75.83-.75.46 0 .831.336.831.75s-.371.75-.83.75c-.46 0-.831-.336-.831-.75z"
                    ></path>
                  </g>
                </g>
              </svg>
            </a>
            <div
              class="share-document-box"
              onclick="return null;"
              v-if="team_share_tooltip"
            >
              <p>
                Saving as a Team Document will add this to your Team's Documents
                section and will be visible to all your Team Members.
              </p>
              <p class="mt-3">
                Note - Team Documents cannot be shared as Community Documents.
              </p>
            </div>
          </div>
        </div>

        <div class="custom-control form-field">
          <span class="switch switch-sm">
            <input
              type="checkbox"
              class="switch"
              v-model="shared"
              id="switch-sm"
            />
            <label for="switch-sm">Share as a Community Document</label>
          </span>
          <div class="share-document-info">
            <a
              href="javascript:"
              @mouseover="share_tooltip = true"
              @mouseout="share_tooltip = false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="20"
                viewBox="0 0 23 20"
              >
                <g>
                  <g>
                    <path
                      d="M11.43 11.5c-.46 0-.831-.387-.831-.865v-5.77c0-.478.372-.865.83-.865.46 0 .831.387.831.865v5.77c0 .478-.372.865-.83.865zM.629 9.75C.629 4.365 5.464 0 11.429 0c5.966 0 10.802 4.365 10.802 9.75S17.395 19.5 11.43 19.5C5.464 19.5.629 15.135.629 9.75zm19.94 0c0-4.556-4.092-8.25-9.14-8.25-5.047 0-9.139 3.694-9.139 8.25S6.382 18 11.43 18c5.047 0 9.139-3.694 9.139-8.25zm-9.97 5c0-.414.372-.75.83-.75.46 0 .831.336.831.75s-.371.75-.83.75c-.46 0-.831-.336-.831-.75z"
                    ></path>
                  </g>
                </g>
              </svg>
            </a>
            <div
              class="share-document-box"
              onclick="return null;"
              v-if="share_tooltip"
            >
              <p>
                Sharing this as a Community Document allows anyone using the
                Analyst Hub to see your document. This might be useful if you
                are looking for feedback or if you simply enjoy sharing your
                crafts with like-minded people.
              </p>
            </div>
          </div>
        </div>
        <span
          class="invalid-feedback"
          v-if="team_shared == true && shared == true"
          >You can not share with both team and community, please choose
          one.</span
        >
        <div class="form-btn">
          <button
            class="btn btn-primary"
            @click="createEmptyDoc()"
            :disabled="!name || (team_shared == true && shared == true)"
          >
            SAVE
          </button>
        </div>
      </div>
      <div class="document-has-been-saved" v-if="confirmed">
        <h4>Your Document has been saved!</h4>
        <div class="thanks-check">
          <img src="/assets/img/check-icon-big.svg" alt="" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import tinymce from "vue-tinymce-editor";

export default {
  name: "DocName",
  components: { tinymce },
  props: {
    docData: {
      type: Object,
      default: () => ({
        name: "",
        description: "",
        shared: false,
      }),
    },
  },
  data: function () {
    return {
      share_tooltip: false,
      team_share_tooltip: false,
      name: "",
      description: this.docData.description || "",
      shared: false,
      team_shared: false,
      confirmed: false,
      userData: null,
      tinymceOptions: {
        // plugins: 'placeholder',
        menubar: false,
        branding: false,
        statusbar: false,
        content_style:
          "body { font-family: 'Poppins', sans-serif; padding-left: 17px; color: #16181F;\n" +
          "    font-size: 14px;\n" +
          "    font-weight: 400;\n" +
          "    line-height: normal; }",
        // placeholder_attrs:"Description..."
        link_title: false,
        contextmenu: "link image",
      },
      tinyKey: 23,
      toolbar1:
        "formatselect | bold italic strikethrough | link | numlist bullist outdent indent",
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
    }),
  },
  mounted() {
    if (this.isLoggedIn) {
      this.userData = JSON.parse(localStorage.getItem("user"));
      if (this.userData.free_plan && this.userData.documents_count >= 3) {
        this.$router.push({ name: "Documents Limit" });
      }
    }
    if (!!this.docData.name) {
      this.name = this.docData.name;
        this.description = this.docData.description || "";
      this.shared = this.docData.shared;
    }
  },
  methods: {
    editorIsInit(e) {
      this.$refs.tm.editor.setContent(this.description)
    },
    createEmptyDoc: function () {
      this.confirmed = true;
      let data = {
        name: this.name,
        description: this.description,
        shared: this.shared,
        team_shared: this.team_shared,
      };
      this.$parent.saveDoc(data); // will be redirected after 2 seconds
    },
  },
};
</script>

<style scoped>
.save-document-form div.custom-control {
  z-index: unset;
}
.save-document-form
  div.custom-control
  .share-document-info
  div.share-document-box {
  z-index: 1;
}
</style>
